import React from "react";
import PublicPageLayout from "../components/PublicPageLayout";

export default function Privacy() {
  return (
    <PublicPageLayout eyebrow="Legal" title="Privacy Policy" subtitle="Last updated: July 2026">
      <p>
        This Privacy Policy explains what information Adyap ("we", "us") collects when you use the Adyap app, how we
        use it, and the choices you have. By using Adyap, you agree to the practices described here.
      </p>

      <h2>Information we collect</h2>
      <p>We collect information you give us directly and information generated as you use the product:</p>
      <ul>
        <li>Account details: name, email address, and authentication data, including via Google sign-in.</li>
        <li>Resume content: the text and file you upload so we can analyze your skills against a target role.</li>
        <li>Career goals and preferences: target roles, salary expectations, and timelines you set.</li>
        <li>Progress data: tasks completed, proof submitted, streaks, interview responses, and readiness scores.</li>
        <li>Usage data: pages visited and actions taken within the app, collected automatically.</li>
      </ul>

      <h2>How we use your information</h2>
      <ul>
        <li>To generate and personalize your skill-gap analysis and day-by-day roadmap.</li>
        <li>To power AI features, including resume parsing, roadmap generation, and mock interview feedback, using
          Google's Gemini models. Relevant excerpts of your resume and roadmap context are sent to Gemini to
          generate these results.</li>
        <li>To authenticate you and keep your account secure.</li>
        <li>To maintain and improve Adyap, including debugging and understanding how features are used.</li>
        <li>To contact you about your account or material changes to the product.</li>
      </ul>

      <h2>How we share information</h2>
      <p>
        We do not sell your personal data. We share information only with the service providers that make Adyap
        work, such as our database and hosting infrastructure, Google (for sign-in and Gemini AI processing), and
        similar processors bound by their own confidentiality and data-protection obligations, or when required by
        law.
      </p>

      <h2>Data retention</h2>
      <p>
        We retain your account and roadmap data for as long as your account is active, so your progress and history
        remain available to you. You can request deletion of your account and associated data at any time.
      </p>

      <h2>Your rights and choices</h2>
      <ul>
        <li>Access, correct, or export the personal data in your account from Settings.</li>
        <li>Request deletion of your account and data by contacting us.</li>
        <li>Opt out of non-essential email communications at any time.</li>
      </ul>

      <h2>Cookies and similar technologies</h2>
      <p>
        We use essential cookies and local storage to keep you signed in and remember your preferences. We do not
        use third-party advertising trackers.
      </p>

      <h2>Children's privacy</h2>
      <p>Adyap is intended for users who are at least 16 years old. We do not knowingly collect data from children.</p>

      <h2>Changes to this policy</h2>
      <p>
        We may update this Privacy Policy as Adyap evolves. If we make material changes, we'll notify you in the
        app or by email before they take effect.
      </p>

      <h2>Contact us</h2>
      <p>
        Questions about this policy or your data? Email us at{" "}
        <a href="mailto:hello@adyap.in">hello@adyap.in</a>.
      </p>
    </PublicPageLayout>
  );
}
